var map = {
	"./abb-color.svg": 1720,
	"./afb-color.svg": 1721,
	"./afb.svg": 1722,
	"./alb-color.svg": 1723,
	"./alb.svg": 1724,
	"./amb-color.svg": 1725,
	"./amb.svg": 1726,
	"./bbbaidja-color.svg": 1727,
	"./bbbaidjaxxx-color.svg": 1728,
	"./bdinidjaxxx-color.svg": 1729,
	"./bimb-color.svg": 1730,
	"./bimb.svg": 1731,
	"./bkr-color.svg": 1732,
	"./bkr.svg": 1733,
	"./bmriidja-color.svg": 1734,
	"./bniaidja-color.svg": 1735,
	"./bninidja-color.svg": 1736,
	"./bninidjaxxx-color.svg": 1737,
	"./bpay-color.svg": 1738,
	"./brinidja002-color.svg": 1739,
	"./bsmdidjaxxx-color.svg": 1740,
	"./bsn-color.svg": 1741,
	"./bsn.svg": 1742,
	"./btanidjaxxx-color.svg": 1743,
	"./cenaidja-color.svg": 1744,
	"./cenaidjaxxx-color.svg": 1745,
	"./cimb-color.svg": 1746,
	"./cimb.svg": 1747,
	"./citi-color.svg": 1748,
	"./citi.svg": 1749,
	"./default-bank-icon-color.png": 1750,
	"./default-bank-icon.png": 1751,
	"./gxbank-color.svg": 1752,
	"./hlb-color.svg": 1753,
	"./hlb.svg": 1754,
	"./hsbc-color.svg": 1755,
	"./hsbc.svg": 1756,
	"./ibbkidjaxxx-color.svg": 1757,
	"./kwh-color.svg": 1758,
	"./kwh.svg": 1759,
	"./mbb-color.svg": 1760,
	"./mbb.svg": 1761,
	"./nispidjaxxx-color.svg": 1762,
	"./ocbc-color.svg": 1763,
	"./ocbc.svg": 1764,
	"./pbb-color.svg": 1765,
	"./pbb.svg": 1766,
	"./pinbidja-color.svg": 1767,
	"./rhb-b.svg": 1768,
	"./rhb-color-b.svg": 1769,
	"./rhb-color.svg": 1770,
	"./rhb.svg": 1771,
	"./scb-color.svg": 1772,
	"./scb.svg": 1773,
	"./tng-color.svg": 1774,
	"./uob-color.svg": 1775,
	"./uob.svg": 1776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;